import React, { useEffect, useState } from 'react';
import Axios from '../../lib/axios/axiosInstance';
import Breadcrumbs from '../Breadcrumbs';
import { Row, Col, Container, Tabs, Tab } from 'react-bootstrap';
import ProdustDetailRight from '../ProductDetailRight';
import ProductInformation from '../ProductInformation/ProductInformation';
import Reviews from '../Reviews/Reviews';
import Enquiry from '../Enquiry/Enquiry';
import RelatedProductsSlider from '../RelatedProductsSlider/RelatedProductsSlider';
import BrandLogoSlider from '../BrandLogoSlider/BrandLogoSlider';
import ProductDetailImage from '../ProductDetailImage/ProductDetailImage';
import './ProductDetail.styles.css';
import * as AuthVerify from '../../lib/common';
import { useParams , useSearchParams,useNavigate } from "react-router-dom";
import {BASE_URL} from '../../lib/constant';

const ProductDetail = ({dispatch}) => {
  const [productDetails, setProductDetails] = useState(null);
  const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
  const [shareUrl, setShareUrl] = useState('');

  const getProductDetails = async (matnum) => {
    let url=`product/productdetails/${matnum}`;
    setShareUrl(`${window.location.href}`);
    await Axios.get(url)
    .then(async function (response) {
        if (response && response.data) {
          setProductDetails(response.data);
          // response.data.matm.imageurl=`${BASE_URL}${response.data.matm.imageurl}`;
          response.data.matm.imageurl=AuthVerify.getImageLink(`${response.data.matm.imageurl}`);
          await AuthVerify.setProductDetails(response.data).then((data) => {
            if(data){
                dispatch({type:'PRODUCT'});
            }
          })
        }
        else {
          navigate('/');
        }
    })
    .catch(function (error) {
      navigate('/');
    });
  };

  useEffect(async () => {
     const matnum=searchParams.get("matnum");
     if(matnum){
      getProductDetails(matnum);
      AuthVerify.addToRecents(matnum)
     }
    }, [searchParams])

  return (
    <>
      <Breadcrumbs />
      <section className="main-container col1-layout">
        <div className="main">
          <Container>
            <Row>
            {productDetails!=null?
            <>
              <div className="col-main">
                <div className="product-view">
                  <div className="product-essential">
                    <Col lg={5} sm={6} xs={12} className="product-img-box">
                      <ProductDetailImage imageurl={AuthVerify.getImageLink(productDetails?.matm?.imageurl)} productName={productDetails?.matm?.matname} baseUrl={BASE_URL} productDetails={productDetails}/>
                    </Col>
                    <Col lg={7} sm={6} xs={12} className="product-shop">
                      <ProdustDetailRight productDetail={productDetails} shareLink={shareUrl}/>
                    </Col>
                  </div>
                </div>
              </div>
              

              <Col lg={12} sm={12} xs={12} className="product-collateral">
                <Tabs defaultActiveKey="Product Information" id="product-detail-tab" className="mb-3 product-tabs">
                  <Tab eventKey="Product Information" title="Product Information" className='productTabContent'>
                    <ProductInformation productDetail={productDetails} />
                  </Tab>
                  <Tab eventKey="Reviews" title="Reviews" className='productTabContent'>
                    <Reviews productDetail={productDetails}/>
                  </Tab>
                  <Tab eventKey="Enquiry" title="Enquiry" className='productTabContent'>
                    <Enquiry productDetail={productDetails?.matm} />
                  </Tab>
                </Tabs>
              </Col>
              </>:<></>
            }
            </Row>
          </Container>

          <RelatedProductsSlider />

          <BrandLogoSlider />

        </div>
      </section>
    </>
  );
};

export default ProductDetail;
